/**
 * export default
 */

export default from './Validator';



// WEBPACK FOOTER //
// ./src/index.js